import { lazy } from 'react';

import Login from './login';

export default {
  Login,

  // Dash: lazy(() => import('./dash')),
};
